(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alnashir-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAHS(root){
    var track = root.querySelector('[data-ahs-track]');
    var slides = root.querySelectorAll('[data-ahs-slide]');
    var dots = root.querySelectorAll('[data-ahs-dot]');
    var prevBtn = root.querySelector('[data-ahs-prev]');
    var nextBtn = root.querySelector('[data-ahs-next]');
    if (!track || slides.length < 1) return;

    var count = slides.length;
    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var speed = parseInt(root.getAttribute('data-transition'), 10) || 700;
    var timer = null;
    var isRTL = getComputedStyle(root).direction === 'rtl';

    track.style.transition = 'transform ' + speed + 'ms cubic-bezier(.65,.05,.2,1)';

    function goTo(index, userInitiated){
      current = (index + count) % count;
      var pct = current * 100;
      track.style.transform = 'translateX(' + (isRTL ? pct : -pct) + '%)';
      slides.forEach(function(s, i){ s.classList.toggle('is-active', i === current); });
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === current); });
      if (userInitiated) restart();
    }

    function next(){ goTo(current + 1); }
    function prev(){ goTo(current - 1); }

    function start(){
      if (!autoplay || count < 2) return;
      stop();
      timer = setInterval(next, interval);
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function restart(){ if (autoplay) { stop(); start(); } }

    if (nextBtn) nextBtn.addEventListener('click', function(){ isRTL ? goTo(current - 1, true) : goTo(current + 1, true); });
    if (prevBtn) prevBtn.addEventListener('click', function(){ isRTL ? goTo(current + 1, true) : goTo(current - 1, true); });
    dots.forEach(function(dot){
      dot.addEventListener('click', function(){ goTo(parseInt(dot.getAttribute('data-goto'), 10), true); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var startX = null;
    track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; stop(); }, { passive:true });
    track.addEventListener('touchend', function(e){
      if (startX === null) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        var goNext = isRTL ? diff > 0 : diff < 0;
        goNext ? goTo(current + 1, true) : goTo(current - 1, true);
      } else {
        restart();
      }
      startX = null;
    });

    goTo(0, false);
    start();

    document.addEventListener('shopify:section:unload', function(e){
      if (e.target.contains(root)) stop();
    });
  }

  document.querySelectorAll('[data-ahs]').forEach(initAHS);

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-ahs]');
    if (el) initAHS(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"]) return;
  try {
    
  (function () {
    function initRelatedCarousel(root) {
      if (!root || root.dataset.relatedReady === 'true') return;

      var viewport = root.querySelector('[data-related-viewport]');
      var track = root.querySelector('.arp__track');
      var previous = root.querySelector('[data-related-previous]');
      var next = root.querySelector('[data-related-next]');
      if (!viewport || !track || !previous || !next) return;

      root.dataset.relatedReady = 'true';

      var autoplay = root.dataset.autoplay === 'true';
      var delay = Math.max(parseInt(root.dataset.autoplayDelay, 10) || 6000, 4000);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = 0;
      var visible = true;
      var hovering = false;
      var focused = false;
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startScrollLeft = 0;
      var blockClick = false;

      function maxScroll() {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function pageDistance() {
        var item = track.querySelector('.arp__item');
        if (!item) return viewport.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        var step = item.getBoundingClientRect().width + gap;
        var itemsPerPage = Math.max(1, Math.floor((viewport.clientWidth + gap) / step));
        return step * itemsPerPage;
      }

      function updateControls() {
        var maximum = maxScroll();
        var current = viewport.scrollLeft;
        root.classList.toggle('is-static', maximum < 2);
        previous.disabled = current <= 2;
        next.disabled = current >= maximum - 2;
      }

      function stop() {
        window.clearTimeout(timer);
        timer = 0;
      }

      function canPlay() {
        return autoplay && !reducedMotion && visible && !hovering && !focused && !dragging && !document.hidden && maxScroll() > 2;
      }

      function schedule(wait) {
        stop();
        if (!canPlay()) return;
        timer = window.setTimeout(function () {
          var maximum = maxScroll();
          var destination = viewport.scrollLeft >= maximum - 2 ? 0 : Math.min(maximum, viewport.scrollLeft + pageDistance());
          viewport.scrollTo({ left: destination, behavior: 'smooth' });
          schedule(delay);
        }, wait || delay);
      }

      function move(direction) {
        stop();
        viewport.scrollBy({ left: pageDistance() * direction, behavior: 'smooth' });
        schedule(delay);
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });

      viewport.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });

      viewport.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateControls);
      }, { passive: true });

      viewport.addEventListener('mouseenter', function () {
        hovering = true;
        stop();
      });

      viewport.addEventListener('mouseleave', function () {
        hovering = false;
        if (!dragging) schedule(5000);
      });

      viewport.addEventListener('focusin', function () {
        focused = true;
        stop();
      });

      viewport.addEventListener('focusout', function (event) {
        if (viewport.contains(event.relatedTarget)) return;
        focused = false;
        schedule(5000);
      });

      viewport.addEventListener('pointerdown', function (event) {
        stop();
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, form')) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScrollLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      });

      viewport.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var distance = event.clientX - startX;
        if (Math.abs(distance) > 5 && !moved) {
          moved = true;
          viewport.setPointerCapture(event.pointerId);
        }
        if (moved) event.preventDefault();
        viewport.scrollLeft = startScrollLeft - distance;
      });

      function finishDrag(event) {
        if (event.pointerType !== 'mouse') {
          schedule(5000);
          return;
        }
        if (!dragging) return;
        dragging = false;
        hovering = false;
        focused = false;
        viewport.classList.remove('is-dragging');
        blockClick = moved;
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        if (viewport.contains(document.activeElement)) document.activeElement.blur();
        window.setTimeout(function () { blockClick = false; }, 0);
        schedule(5000);
      }

      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);

      viewport.addEventListener('click', function (event) {
        if (!blockClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else schedule(3000);
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) schedule(3000);
          else stop();
        }, { threshold: 0.2 });
        observer.observe(root);
      }

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(viewport);
      }

      updateControls();
      schedule(3000);
    }

    function initAll(scope) {
      var parent = scope || document;
      var roots = parent.querySelectorAll('[data-related-carousel]');
      for (var i = 0; i < roots.length; i += 1) initRelatedCarousel(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
